import { TagModelSchemaType } from './types';
import { tagCoreModel } from './tag-core-model';

export const tagModel: TagModelSchemaType = {
    ...tagCoreModel,
};
